import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d9d36bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"grid","align-self":"start","height":"calc(100% - 35px)","grid-auto-rows":"max-content auto"} }
const _hoisted_2 = { class: "service-credentials" }
const _hoisted_3 = { class: "input-wrapper" }
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between","width":"100%"} }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", {
        class: _normalizeClass(_ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light')
      }, "Component " + _toDisplayString(_ctx.service.service.index) + " - Private image credentials", 3),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.credentialFields.userName.value) = $event)),
          onInput: _cache[1] || (_cache[1] = (e) => _ctx.credentialFields.userName.valid = _ctx.credentialFields.userName.value.length > 0),
          placeholder: "Username",
          class: _normalizeClass([_ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light', "stepper-input"]),
          type: "text"
        }, null, 34), [
          [_vModelText, _ctx.credentialFields.userName.value]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.credentialFields.userPassword.value) = $event)),
            placeholder: "Password",
            class: _normalizeClass([_ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light', "stepper-input"]),
            type: "password",
            autocomplete: "new-password",
            onInput: _cache[3] || (_cache[3] = (e) => _ctx.credentialFields.userPassword.valid = _ctx.credentialFields.userPassword.value.length > 0),
            onFocusout: _cache[4] || (_cache[4] = (e) => _ctx.credentialFields.userPassword.valid = _ctx.credentialFields.userPassword.value.length > 0),
            title: "Enter a password 12 character long with at least: 1 uppercase, 1 digit, 1 special character"
          }, null, 34), [
            [_vModelText, _ctx.credentialFields.userPassword.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('back'))),
        class: "confirm"
      }, "Back"),
      _createElementVNode("button", {
        disabled: !_ctx.credentialFields.userName.valid || !_ctx.credentialFields.userPassword.valid,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('confirm', {data: {userName: _ctx.credentialFields.userName.value, userPassword: _ctx.credentialFields.userPassword.value}, index: _ctx.service.index, field: 'privateImage'}))),
        class: "cancel"
      }, "Save", 8, _hoisted_5)
    ])
  ], 64))
}